import { toast } from "react-toastify";

import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const BRAND_USED_ON_USERS_ERROR = /brand cannot be deleted, still used on \d+ users/;

type DeleteBrandPayload = {
  id: number;
  is_confirmed: boolean;
};

export const useDeleteBrandMutation = () =>
  useTypedMutation({
    mutationFn: ({ id, is_confirmed }: DeleteBrandPayload) => ApiInstance.post("/brands/delete", { id, is_confirmed }, ENV.carBaseURL),
    onSuccess: ({ id }) => {
      const previousBrands = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brands);
      if (!previousBrands) return;

      const brandIdx = previousBrands.findIndex(brand => brand.id === id);
      if (brandIdx === -1) return;

      typedQueryClient.setQueryData(BrandsDashboardQueryKeys.brands, previousBrands.toSpliced(brandIdx, 1));

      const brandGroups = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brandGroups);
      if (!brandGroups) return;

      const groupIdx = brandGroups.findIndex(group => group.id === previousBrands[brandIdx].brand_group_id);
      if (groupIdx === -1) return;

      const brandGroup = brandGroups[groupIdx];
      typedQueryClient.setQueryData(
        BrandsDashboardQueryKeys.brandGroups,
        brandGroups.with(groupIdx, { ...brandGroup, brands: brandGroup.brands?.filter(brand => brand.id !== id) })
      );
    },
    onError: error => {
      if (BRAND_USED_ON_USERS_ERROR.test(error.message)) return;
      toast.error(error.message);
    }
  });
